import React from "react";
import "../wizard.component.scoped.scss";
import {
  Box,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
} from "@material-ui/core";
import { useTranslation } from "react-i18next";
import {
  CreateWorkspaceWizardData,
  WizardStepProps,
} from "../../../types/create-workspace-wizard";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";

type Props = WizardStepProps<CreateWorkspaceWizardData["step3"]>;

const WizardStep3: React.FC<Props> = ({ data, onChange, errors }) => {
  const { t } = useTranslation();
  const subscriptionPlans: number[] = [6, 12, 24, 36];
  const [touched, setTouched] = React.useState<
    Partial<Record<keyof CreateWorkspaceWizardData["step3"], boolean>>
  >({});

  const updateField = (
    field: keyof CreateWorkspaceWizardData["step3"],
    value: string,
  ) => {
    setTouched(
      (
        prev: Partial<
          Record<keyof CreateWorkspaceWizardData["step3"], boolean>
        >,
      ) => ({ ...prev, [field]: true }),
    );
    onChange({ ...data, [field]: value });
  };

  return (
    <Box
      className="global__box__content product__details__content__form p-0"
      style={{ height: "fit-content" }}
    >
      <Box className="global__box__content__header">
        <Typography
          className="text-capitalize"
          variant="h3"
          color="textPrimary"
        >
          {t("WORKSPACE_WIZARD.COORDINATOR_INFORMATION")}
        </Typography>
      </Box>
      <Box className="global__box__content__body">
        <Box className="form__item">
          <Typography variant="subtitle2">{t("FIRST_NAME")}</Typography>
          <Box className="standard_text_input">
            <TextField
              placeholder={t("FIRST_NAME")}
              variant="standard"
              name="coordinatorFirstName"
              value={data.coordinatorFirstName}
              className="w-100"
              onChange={(e) =>
                updateField("coordinatorFirstName", e.target.value)
              }
              inputProps={{
                maxLength: 30,
              }}
            />
            {touched.coordinatorFirstName && errors?.coordinatorFirstName && (
              <Typography
                variant="body2"
                className="mt-2"
                color="error"
                style={{ fontWeight: 300 }}
              >
                {errors.coordinatorFirstName === "REQUIRED"
                  ? t("THIS_FIELD_IS_REQUIRED")
                  : t("INVALID_FORMAT_ONLY_SPECIAL_CHARACTERS_STRINGS_ALLOWED")}
              </Typography>
            )}
          </Box>
        </Box>
        <Box className="form__item">
          <Typography variant="subtitle2">{t("LAST_NAME")}</Typography>
          <Box className="standard_text_input">
            <TextField
              placeholder={t("LAST_NAME")}
              variant="standard"
              name="coordinatorLastName"
              value={data.coordinatorLastName}
              className="w-100"
              onChange={(e) =>
                updateField("coordinatorLastName", e.target.value)
              }
              inputProps={{
                maxLength: 30,
              }}
            />
            {touched.coordinatorLastName && errors?.coordinatorLastName && (
              <Typography
                variant="body2"
                className="mt-2"
                color="error"
                style={{ fontWeight: 300 }}
              >
                {errors.coordinatorLastName === "REQUIRED"
                  ? t("THIS_FIELD_IS_REQUIRED")
                  : t("INVALID_FORMAT_ONLY_SPECIAL_CHARACTERS_STRINGS_ALLOWED")}
              </Typography>
            )}
          </Box>
        </Box>
        <Box className="form__item">
          <Typography variant="subtitle2">{t("EMAIL")}</Typography>
          <Box className="standard_text_input">
            <TextField
              placeholder={t("EMAIL")}
              variant="standard"
              name="coordinatorEmail"
              value={data.coordinatorEmail}
              className="w-100"
              onChange={(e) => updateField("coordinatorEmail", e.target.value)}
            />
            {touched.coordinatorEmail && errors?.coordinatorEmail && (
              <Typography
                variant="body2"
                className="mt-2"
                color="error"
                style={{ fontWeight: 300 }}
              >
                {errors.coordinatorEmail === "REQUIRED"
                  ? t("THIS_FIELD_IS_REQUIRED")
                  : t("INVALID_EMAIL_FORMAT")}
              </Typography>
            )}
          </Box>
        </Box>
        <Box className="form__item">
          <Typography variant="subtitle2">{t("COMPANY")}</Typography>
          <Box className="standard_text_input">
            <TextField
              placeholder={t("COMPANY")}
              variant="standard"
              name="coordinatorCompany"
              value={data.coordinatorCompany}
              className="w-100"
              onChange={(e) =>
                updateField("coordinatorCompany", e.target.value)
              }
              inputProps={{
                maxLength: 30,
              }}
            />
            {touched.coordinatorCompany && errors?.coordinatorCompany && (
              <Typography
                variant="body2"
                className="mt-2"
                color="error"
                style={{ fontWeight: 300 }}
              >
                {errors.coordinatorCompany === "REQUIRED"
                  ? t("THIS_FIELD_IS_REQUIRED")
                  : t("INVALID_FORMAT_ONLY_SPECIAL_CHARACTERS_STRINGS_ALLOWED")}
              </Typography>
            )}
          </Box>
        </Box>
        <Box className="form__item">
          <Typography variant="subtitle2">{t("SUBSCRIPTION")}</Typography>
          <Box className="standard_text_input">
            <FormControl className="select-input w-100">
              {!data.coordinatorSubscription && (
                <InputLabel id="subscription">{t("SUBSCRIPTION")}</InputLabel>
              )}
              <Select
                labelId="subscription"
                id="subscription-select"
                name="coordinatorSubscription"
                variant="standard"
                value={data.coordinatorSubscription}
                onChange={(e: any) =>
                  updateField("coordinatorSubscription", e.target.value)
                }
                IconComponent={ExpandMoreIcon}
              >
                {subscriptionPlans.map((item: any, index: number) => {
                  return (
                    <MenuItem value={item} key={index}>
                      {item} {t("MONTHS")}
                    </MenuItem>
                  );
                })}
              </Select>
            </FormControl>
            {touched.coordinatorSubscription &&
              errors?.coordinatorSubscription && (
                <Typography
                  variant="body2"
                  className="mt-2"
                  color="error"
                  style={{ fontWeight: 300 }}
                >
                  {t("THIS_FIELD_IS_REQUIRED")}
                </Typography>
              )}
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default WizardStep3;
